import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class SupplierInvoiceTableHeader extends Component {

  static Layout = [
    { column: "chargeType", width: 2, name: "Charge Type" },
    { column: "quantity", width: 2 },
    { column: "factor", width: 2 },
    { column: "chargeRate", name: "Charge Rate" },
    { column: "chargeUnit", name: "Charge Unit" },
    { column: "nettValue", name: "Nett Value" },
    { column: "levyValue", width: 2, name: "Levy Value" },
    { column: "grossValue", name: "Gross Value" }

  ];

  render() {
    return (
        <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={SupplierInvoiceTableHeader.Layout}/>
    )
  }
}